// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"118":"34216ced","668":"e5e53b83"}[chunkId] + ".css";
};